export default __webpack_public_path__ + "static/media/Hanh phuc.a7b54529.png";